import React from "react";
import { useLocation, Link } from "react-router-dom";

const NavbarLinks = ({ isMobileMenuOpen, closeMobileMenu }) => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const links = [
    { path: "/", label: "home." },
    { path: "/music", label: "music." },
    { path: "/software", label: "software." },
    { path: "/games", label: "games." },
    { path: "/academia", label: "academia." },
    { path: "/contact", label: "contact." },
    { path: "/garden", label: "garden 🌿" },
  ];

  return (
    <div className={`navlinks ${isMobileMenuOpen ? "mobile-open" : ""}`}>
      {links.map((link, index) => (
        <React.Fragment key={link.path}>
          {link.path === "/garden" && <div className="nav-separator" />}
          <Link
            to={link.path}
            className={`nav-link ${isActive(link.path) ? "active" : ""}`}
            onClick={closeMobileMenu}
          >
            {link.label}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
};

export default NavbarLinks;
